import type { PublicVideo, PublicVideoInput } from "@pushup/types";
import { api, WITH_CREDENTIALS } from "@/lib/api";

/** Fetches the public clip feed, newest first. Sends the session cookie. */
export function listPublicVideos(): Promise<PublicVideo[]> {
  return api.get<PublicVideo[]>("/public-videos", WITH_CREDENTIALS);
}

/** A clip ready to upload: metadata plus the raw bytes. */
export interface PublicVideoUpload extends PublicVideoInput {
  blob: Blob;
}

/**
 * Removes one of the signed-in user's own clips. The backend also deletes the
 * R2 bytes; returns 204 on success.
 */
export function deletePublicVideo(id: string): Promise<void> {
  return api.request<void>(`/public-videos/${encodeURIComponent(id)}`, {
    ...WITH_CREDENTIALS,
    method: "DELETE",
  });
}

/**
 * Posts a clip to the public feed. The bytes travel as the raw request body
 * (streamed into R2); metadata rides in request headers so the D1 row stays
 * tiny and clips up to 100 MB are supported. Requires a signed-in session
 * cookie, which is sent along with the request.
 */
export function createPublicVideo(upload: PublicVideoUpload): Promise<PublicVideo> {
  return api.request<PublicVideo>("/public-videos", {
    ...WITH_CREDENTIALS,
    method: "POST",
    body: upload.blob,
    headers: {
      "content-type": upload.mimeType,
      "x-clip-name": upload.name,
      "x-clip-duration-sec": String(upload.durationSec),
      "x-clip-reps": String(upload.reps),
      "x-clip-celebrity-name": upload.celebrityName ?? "",
    },
  });
}
